<template>
    <div :parentProps="parentProps">
        <el-input 
        v-model="val" 
        v-bind="{placehoder, size, border, clearable}"
        @change="changeHandler" prefix-icon="el-icon-full-screen">
        </el-input>
    </div>
</template>

<script>
import {get, set} from 'lodash';
export default {
    name: 'l-scanCode',
    props: {
        value:{
          type:[String,Number],
          default:''
        },
        size: {
          type:String,
          default:'mini'
        },
        border:Boolean,
        disabled:Boolean,
        placehoder: {
            default: ''
        },
        clearable: {
            default: true
        },
        dataApi: {
            default: ''
        },
        dataMethod: {
            default: 'get'
        },
        dataTable: {
            default: () => {
                return []
            }
        },
        dataChildTable: {
            default: () => {
                return []
            }
        },
        setPropVal: Function
    },
    computed: {
        parentProps () {
            let obj = {}
            this.dataChildTable.forEach(e => {
                let arr = e.prop.split('.'),
                    item = this.dataTable.find(i => i.prop == arr[0])
                
                if (item) {
                    obj[item.prop] = item.key
                }
            })
            return obj
        }
    },
    data() {
        return {
            val: ''
        };
    },
    watch: {
        value() {
            this.val = this.value
        },
    },
    mounted () {
        this.val = this.value
    },
    methods: {
        changeHandler () {
            this.$emit('input', this.val)
            this.$emit('change', this.val)
            if (!this.val) return
            window.$axios({
                url: this.dataApi.replace('{val}', this.val).slice(1),
                method: 'get'
            }).then(res => {
                if (res && res.data && res.data.data) {
                    let data = res.data.data
                    this.dataTable.forEach(e => {
                        if (this.parentProps[e.prop] && e.prop && e.key) {
                            let arr = get(data, e.key, []),
                                brr = [],
                                childs = this.dataChildTable.filter(i => i.prop && i.key && (i.prop.indexOf(e.prop) > -1))
                            arr.forEach(i => {
                                let obj = {}
                                childs.forEach(j => {
                                    obj[j.prop.split('.')[1]] = i[j.key]
                                })
                                brr.push(obj)
                            })
                            this.setPropVal({
                                path: e.prop,
                                value: brr
                            })
                        } else {
                            e.prop && e.key && this.setPropVal({
                                path: e.prop,
                                value: get(data, e.key)
                            })
                        }
                        
                    })
                }
                
            })
        }
    }
}
</script>
<style scoped>
    
</style>